import NUME_EXT_1 from "./NUME_EXT_1";
export default {
  NUME_EXT_1,
};
